/**
 * Eratec Sprach-Empfehlungs-Banner.
 *
 * Browsersprachbasierte Empfehlung OHNE Auto-Redirect (SEO/hreflang bleiben
 * unberuehrt). Liest alle Werte ausschliesslich aus dem DOM (#eratec-lb +
 * #eratec-lb-langs) — keine Liquid-Interpolation hier. Ausgelagert aus
 * sections/eratec-language-banner.liquid (PERF-03): statt ~125 Zeilen Inline-JS
 * pro Seitendokument jetzt eine einmal gecachte, deferte Datei.
 */
(function () {
  'use strict';

  var root = document.getElementById('eratec-lb');
  var dataEl = document.getElementById('eratec-lb-langs');
  if (!root || !dataEl) return;

  var langs;
  try { langs = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!langs || !langs.length) return;

  var available = {};
  langs.forEach(function (l) {
    var iso = (l && l.iso ? String(l.iso) : '').toLowerCase();
    if (iso) available[iso] = l.name;
  });

  var current = String(root.getAttribute('data-current') || '').toLowerCase().split('-')[0];

  // Zielsprache: erste Browsersprache, die der Shop tatsaechlich anbietet.
  function detect() {
    var nav = (navigator.languages && navigator.languages.length)
      ? navigator.languages
      : [navigator.language || ''];
    for (var i = 0; i < nav.length; i++) {
      var p = String(nav[i] || '').toLowerCase().split('-')[0];
      if (p && available[p]) return p;
    }
    return null;
  }

  var target = detect();
  // Browsersprache wird nicht angeboten -> Englisch als internationale Bruecke vorschlagen.
  if (!target && available.en) target = 'en';
  if (!target || target === current) return;

  var KEY = 'eratec_lrb_dismissed_v1';
  var force = root.getAttribute('data-force-show') === 'true';
  var dismissDays = parseInt(root.getAttribute('data-dismiss-days'), 10);
  if (isNaN(dismissDays) || dismissDays < 1) dismissDays = 180;

  function fire(name, detail) {
    try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }
  function isDismissed() {
    if (force) return false;
    try {
      var v = window.localStorage.getItem(KEY);
      if (!v) return false;
      var expiry = parseInt(v, 10);
      if (isNaN(expiry)) return false;
      if (Date.now() > expiry) { window.localStorage.removeItem(KEY); return false; }
      return true;
    } catch (e) { return false; }
  }
  function setDismissed() {
    try { window.localStorage.setItem(KEY, String(Date.now() + dismissDays * 86400000)); } catch (e) {}
  }

  if (isDismissed()) return;

  var endonym = available[target];
  var textEl = root.querySelector('[data-lb-text]');
  var endoEl = root.querySelector('[data-lb-endonym]');
  var switchBtn = root.querySelector('[data-lb-switch]');

  if (textEl) {
    var msg = root.getAttribute('data-message') || '';
    textEl.textContent = msg.split('[language]').join(endonym);
  }
  if (endoEl) endoEl.textContent = endonym;
  if (switchBtn) {
    switchBtn.value = target;
    var al = root.getAttribute('data-switch-label') || '';
    switchBtn.setAttribute('aria-label', al.split('[language]').join(endonym));
  }

  /*
     Hintergrund sperren wie die Ausfuehrungswahl (snippets/eratec-produktkarte.liquid):
     In Horizon 4 scrollt .page-wrapper, nicht das Fenster; Fallback ist der body.
  */
  var rolle = null;
  var stand = null;
  function sperren() {
    var huelle = document.querySelector('.page-wrapper');
    rolle = huelle && huelle.scrollHeight > huelle.clientHeight ? huelle : null;
    if (rolle) {
      stand = rolle.scrollTop;
      rolle.style.overflow = 'hidden';
      rolle.style.touchAction = 'none';
      return;
    }
    stand = window.scrollY;
    var b = document.body.style;
    b.position = 'fixed';
    b.insetInline = '0';
    b.width = '100%';
    b.top = (stand * -1) + 'px';
    b.touchAction = 'none';
  }
  function freigeben() {
    if (stand == null) return;
    if (rolle) {
      rolle.style.overflow = '';
      rolle.style.touchAction = '';
      rolle.scrollTop = stand;
    } else {
      var b = document.body.style;
      b.position = b.insetInline = b.width = b.top = b.touchAction = '';
      window.scrollTo(0, stand);
    }
    stand = null;
  }

  var gewechselt = false;

  // Jeder Weg zu (Kreuz, Bleiben, Escape, Klick auf den Riegel) aendert das open-Attribut;
  // das close-Ereignis bleibt in eingebetteten WebViews aus (siehe eratec-kopf.js).
  new MutationObserver(function () {
    if (root.open) return;
    freigeben();
    if (gewechselt) return;
    setDismissed();
    fire('eratec:lrb:dismissed', { from: current, to: target });
  }).observe(root, { attributeFilter: ['open'] });

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t === root) { root.close(); return; } // Klick auf den Riegel
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('[data-lb-dismiss]')) {
      root.close();
      return;
    }
    if (t.closest('[data-lb-switch]')) {
      // Auswahl merken; das localization-Form uebernimmt das Umschalten + Mapping.
      gewechselt = true;
      setDismissed();
      fire('eratec:lrb:accepted', { from: current, to: target });
    }
  });

  // Escape selbst schliessen: ohne Nutzeraktion geoeffnete Dialoge ignoriert Chrome sonst.
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); root.close(); }
  });

  function show() {
    if (typeof root.showModal !== 'function') return;
    sperren();
    root.showModal();
    fire('eratec:lrb:shown', { from: current, to: target });
  }

  /*
     Nie gleichzeitig mit dem Cookie-Dialog (Pandectes, ebenfalls mittig): showModal
     wuerde ihn inert machen. Gezeigt wird erst, wenn die Einwilligung beantwortet ist
     oder Pandectes nach seinem Start keinen offenen Dialog hat. Ohne Pandectes nach 6 s.
  */
  function einwilligungOffen() {
    var host = document.querySelector('pandectes-cmp');
    var sr = host && host.shadowRoot;
    if (!sr) return null; // Pandectes (noch) nicht da
    var dialoge = sr.querySelectorAll('dialog[open]');
    for (var i = 0; i < dialoge.length; i++) {
      if (!dialoge[i].classList.contains('closing') && dialoge[i].getBoundingClientRect().height > 0) return true;
    }
    return false;
  }

  var start = Date.now();
  var frei = 0;
  (function pruefen() {
    var offen = einwilligungOffen();
    frei = offen === false ? frei + 1 : 0;
    // zwei freie Messungen in Folge: Pandectes baut den Dialog kurz nach dem Host auf
    if (frei >= 2 || (offen === null && Date.now() - start > 6000)) {
      window.setTimeout(show, 300);
      return;
    }
    window.setTimeout(pruefen, 400);
  })();
})();
